
export class SecureGalleryPage {

    constructor() {

        //document.ready
        $(() => {


        });
    }

}